// src/components/brand-result-listing-flights/brand-result-listing-flights.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    orientation\n    size\n    url {\n      ... on HttpURI {\n        __typename\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    text\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment UILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      urls\n    }\n    resource {\n      ... on HttpURI {\n        value\n      }\n    }\n    target\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  query BrandResultListingFlightsQuery($context: ContextInput!, $sponsoredContentContext: SponsoredContentContextInput!) {\n    sponsoredContent {\n      brandResultListingFlights(context: $context, sponsoredContentContext: $sponsoredContentContext) {\n        heading\n        paragraph\n        advertiserName\n        beacons {\n          renderBeacons\n          viewabilityBeacon\n        }\n        link {\n          ...UILinkActionFragment\n        }\n        badge {\n          ...EGDSStandardBadgeFragment\n        }\n        logo {\n          standard {\n            ...EGDSMarkFragment\n          }\n        }\n        callToAction {\n          text\n          action {\n            ...UILinkActionFragment\n          }\n        }\n        impressionAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React9 from "react";
import LazyLoad from "react-lazy-load";
import { gql as gql5, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/ad-block-detect/ad-block-detect.tsx
import React from "react";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { SystemEvent, SystemEventLevel, useLoggerEvents } from "@shared-ui/logger-context";
var AD_BLOCK_DETECTED_EVENT = new SystemEvent(SystemEventLevel.INFO, "AD_BLOCK_DETECTED");
var CollapsedComponent = function() {
    var events = useLoggerEvents({
        AD_BLOCK_DETECTED_EVENT: AD_BLOCK_DETECTED_EVENT
    });
    events.AD_BLOCK_DETECTED_EVENT.log({
        message: "collapsing"
    });
    return null;
};
var UncollapsedWrappedComponent = function(props) {
    var children = props.children;
    var events = useLoggerEvents({
        AD_BLOCK_DETECTED_EVENT: AD_BLOCK_DETECTED_EVENT
    });
    events.AD_BLOCK_DETECTED_EVENT.log({
        message: "not collapsing"
    });
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
function withAdBlockDetect(WrapperComponent) {
    var WithAdBlockDetectHOC = function(componentProps) {
        var collapseWhenAdBlockDetected = componentProps.collapseWhenAdBlockDetected, adBlockCollapseExperiment = componentProps.adBlockCollapseExperiment;
        if (typeof window !== "undefined") {
            var _window_meso;
            window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
            if (!window.meso.adblock || window.meso.adblock.enabled) {
                if (adBlockCollapseExperiment) {
                    return /* @__PURE__ */ React.createElement(Experiment, {
                        name: adBlockCollapseExperiment
                    }, /* @__PURE__ */ React.createElement(ExperimentControl, null, /* @__PURE__ */ React.createElement(CollapsedComponent, null)), /* @__PURE__ */ React.createElement(ExperimentVariant, {
                        bucket: 1
                    }, /* @__PURE__ */ React.createElement(UncollapsedWrappedComponent, null, /* @__PURE__ */ React.createElement(WrapperComponent, _object_spread({}, componentProps)))));
                }
                if (collapseWhenAdBlockDetected === false) {
                    return /* @__PURE__ */ React.createElement(UncollapsedWrappedComponent, null, /* @__PURE__ */ React.createElement(WrapperComponent, _object_spread({}, componentProps)));
                }
                return /* @__PURE__ */ React.createElement(CollapsedComponent, null);
            }
        }
        return /* @__PURE__ */ React.createElement(WrapperComponent, _object_spread({}, componentProps));
    };
    WithAdBlockDetectHOC.displayName = "WithAdBlockDetectHOC";
    return WithAdBlockDetectHOC;
}
// ../internal/src/components/analytics/client-side-analytics.ts
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/egds-mark/egds-mark.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
// ../internal/src/components/egds-mark/utils/index.ts
var markSizeMapper = {
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "10": 10,
    "11": 11,
    "12": 12,
    "13": 13,
    "14": 14,
    "15": 15,
    "16": 16,
    "17": 17,
    "18": 18,
    "24": 24,
    "30": 30,
    "37": 37,
    "38": 38,
    "40": 40,
    "48": 48,
    "72": 72
};
var _obj;
var orientationMap = (_obj = {}, _define_property(_obj, "LANDSCAPE" /* LANDSCAPE */ , "landscape"), _define_property(_obj, "PORTRAIT" /* PORTRAIT */ , "portrait"), _obj);
// ../internal/src/components/egds-mark/egds-mark.tsx
var __EGDSMarkFragment = gql2(_templateObject1());
var EGDSMark = function(param) {
    var className = param.className, size = param.size, data = param.data;
    var _url;
    var description = data.description, id = data.id, orientation = data.orientation, url = data.url;
    var markSize;
    if (size) {
        markSize = markSizeMapper[size];
    } else if (data.size) {
        markSize = markSizeMapper[data.size];
    } else {
        markSize = void 0;
    }
    var markOrientation = orientation && orientationMap[orientation] || "landscape";
    return /* @__PURE__ */ React2.createElement(UitkMark, {
        className: className,
        description: description,
        id: id,
        name: id,
        orientation: markOrientation,
        size: markSize,
        url: (_url = url) === null || _url === void 0 ? void 0 : _url.value
    });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-standard-badge/egds-standard-badge.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkBadgeStandard } from "uitk-react-badge";
var fragment = gql3(_templateObject2());
var EGDSStandardBadge = function(param) {
    var data = param.data;
    if (!data.text) {
        return null;
    }
    var _data_accessibility;
    return /* @__PURE__ */ React3.createElement(UitkBadgeStandard, {
        size: "small",
        text: data.text,
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    });
};
EGDSStandardBadge.fragment = fragment;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// ../internal/src/components/meso-viewability/meso-viewability.ts
import React4, { useCallback } from "react";
var useMesoViewability = function(param) {
    var viewabilityBeacon = param.viewabilityBeacon;
    var componentRef = React4.useRef(null);
    var deRegisterViewability = useCallback(function() {
        if (componentRef.current && window.meso) {
            var _window_meso_viewability;
            window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
            window.meso.viewability.push({
                type: "deregister",
                element: componentRef.current
            });
        }
    }, []);
    var registerViewability = useCallback(function() {
        if (componentRef.current) {
            var _window_meso;
            window.meso = (_window_meso = window.meso) !== null && _window_meso !== void 0 ? _window_meso : {};
            var _window_meso_viewability;
            window.meso.viewability = (_window_meso_viewability = window.meso.viewability) !== null && _window_meso_viewability !== void 0 ? _window_meso_viewability : [];
            window.meso.viewability.push({
                type: "register",
                config: "image",
                // the config settings to use: image, video, or large-image
                element: componentRef.current,
                // reference to the DOM element
                beacon: viewabilityBeacon
            });
        }
    }, [
        viewabilityBeacon
    ]);
    React4.useEffect(function() {
        registerViewability();
        return deRegisterViewability;
    }, [
        registerViewability,
        deRegisterViewability
    ]);
    return {
        componentRef: componentRef
    };
};
// ../internal/src/components/ui-action-link/ui-action-link.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var fragment2 = gql4(_templateObject3());
var _obj1;
var UILinkTargetMap = (_obj1 = {}, _define_property(_obj1, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj1, "INTERNAL" /* INTERNAL */ , "_self"), _obj1);
var UILinkAction = function(param) {
    var className = param.className, data = param.data, children = param.children;
    var accessibility = data.accessibility, resource = data.resource, target = data.target, analytics = data.analytics;
    var clickTracker = useClickTracker2();
    var onClick = React5.useCallback(function() {
        var _analytics_urls, _analytics, _analytics1, _analytics2;
        (_analytics = analytics) === null || _analytics === void 0 ? void 0 : (_analytics_urls = _analytics.urls) === null || _analytics_urls === void 0 ? void 0 : _analytics_urls.forEach(function(url) {
            var _navigator;
            (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.sendBeacon(url);
        });
        if (((_analytics1 = analytics) === null || _analytics1 === void 0 ? void 0 : _analytics1.referrerId) && ((_analytics2 = analytics) === null || _analytics2 === void 0 ? void 0 : _analytics2.linkName)) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        clickTracker
    ]);
    if (resource.__typename !== "HttpURI") {
        return null;
    }
    return /* @__PURE__ */ React5.createElement("a", {
        className: className,
        target: UILinkTargetMap[target],
        href: resource.value,
        rel: "noopener noreferrer",
        onClickCapture: onClick
    }, accessibility && /* @__PURE__ */ React5.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility), children);
};
UILinkAction.fragment = fragment2;
UILinkAction.displayName = "UILinkAction";
// ../internal/src/components/utils/constants.ts
var DEFAULT_SPONSORED_BATCH_KEY = "sponsored-content";
var DEFAULT_SPONSORED_FETCH_POLICY = "no-cache";
// src/components/brand-result-listing-flights/brand-result-listing-flights.tsx
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkCard, UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
// src/components/brand-result-listing-flights/__private/lazy-brand-result-listing-flights-content.tsx
import React7 from "react";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/beacons/use-beacons.tsx
import React6 from "react";
import { useLoggerEvents as useLoggerEvents2 } from "@shared-ui/logger-context";
// ../internal/src/components/utils/logger-utils.ts
import { SystemEvent as SystemEvent2, SystemEventLevel as SystemEventLevel2 } from "@shared-ui/logger-context";
var EVENTS = {
    FAIL_TO_SEND_BEACON_USING_BEACON_API: new SystemEvent2(SystemEventLevel2.WARN, "FAIL_TO_SEND_BEACON_USING_BEACON_API" /* FAIL_TO_SEND_BEACON_USING_BEACON_API */ )
};
// ../internal/src/components/beacons/use-beacons.tsx
var fireBeacon = function(beacon, events) {
    try {
        if (!navigator.sendBeacon(encodeURI(beacon))) {
            events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({});
        }
    } catch (error) {
        events.FAIL_TO_SEND_BEACON_USING_BEACON_API.log({
            error: error
        });
    }
};
var useBeacons = function(beacons) {
    var loggerEvents = useLoggerEvents2(EVENTS);
    React6.useEffect(function() {
        if (beacons) {
            var _beacons_renderBeacons;
            (_beacons_renderBeacons = beacons.renderBeacons) === null || _beacons_renderBeacons === void 0 ? void 0 : _beacons_renderBeacons.forEach(function(impression) {
                fireBeacon(impression, loggerEvents);
            });
        }
    }, []);
};
// src/components/brand-result-listing-flights/__private/lazy-brand-result-listing-flights-content.tsx
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
var LazyBrandResultListingFlightsContent = function(param) {
    var data = param.data, impressionOnly = param.impressionOnly;
    var _logo, _callToAction;
    var badge = data.badge, heading = data.heading, paragraph = data.paragraph, logo = data.logo, beacons = data.beacons, advertiserName = data.advertiserName, callToAction = data.callToAction, impressionAnalytics = data.impressionAnalytics;
    var referrerId = impressionAnalytics.referrerId, linkName = impressionAnalytics.linkName;
    useBeacons(beacons);
    if (impressionOnly) {
        return null;
    }
    return /* @__PURE__ */ React7.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, /* @__PURE__ */ React7.createElement(UitkCardContentSection, null, /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
        wrap: "nowrap",
        justifyContent: "start",
        space: "two",
        alignContent: "start"
    }, ((_logo = logo) === null || _logo === void 0 ? void 0 : _logo.standard) && /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, {
        grow: 0
    }, /* @__PURE__ */ React7.createElement(EGDSMark, {
        data: logo.standard
    })), /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, {
        grow: 8,
        minWidth: "half_width",
        alignSelf: "center"
    }, /* @__PURE__ */ React7.createElement(UitkText, {
        size: 200
    }, advertiserName)), badge && /* @__PURE__ */ React7.createElement(UitkLayoutPosition, {
        position: {
            top: "three",
            right: "three"
        }
    }, /* @__PURE__ */ React7.createElement(EGDSStandardBadge, {
        data: badge
    }))), /* @__PURE__ */ React7.createElement(UitkLayoutFlex, {
        direction: "column",
        justifyContent: "start"
    }, /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(UitkSpacing, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React7.createElement(UitkHeading, {
        tag: "h3",
        size: 6
    }, heading))), /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(UitkText, {
        size: 300,
        spacing: "one"
    }, paragraph)), ((_callToAction = callToAction) === null || _callToAction === void 0 ? void 0 : _callToAction.action) && /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React7.createElement(UitkSpacing, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React7.createElement(UitkLink, {
        inline: true
    }, /* @__PURE__ */ React7.createElement(UILinkAction, {
        data: callToAction.action
    }, callToAction.text)))))));
};
LazyBrandResultListingFlightsContent.displayName = "LazyBrandResultListingFlightsContent";
// src/components/brand-result-listing-flights/__private/lazy-brand-result-listing-smart-shopping-content.tsx
import React8 from "react";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCardContentSection as UitkCardContentSection2, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText2 } from "uitk-react-text";
var brlSpacing = {
    padding: {
        blockend: "three",
        blockstart: "three",
        inline: "six"
    }
};
var LazyBrandResultListingSmartShoppingContent = function(param) {
    var data = param.data, impressionOnly = param.impressionOnly;
    var _logo, _callToAction;
    var badge = data.badge, heading = data.heading, paragraph = data.paragraph, logo = data.logo, beacons = data.beacons, advertiserName = data.advertiserName, callToAction = data.callToAction, impressionAnalytics = data.impressionAnalytics, link = data.link;
    var referrerId = impressionAnalytics.referrerId, linkName = impressionAnalytics.linkName;
    useBeacons(beacons);
    if (impressionOnly) {
        return null;
    }
    return /* @__PURE__ */ React8.createElement(IntersectionTracker2, {
        trackOnce: true,
        referrerId: referrerId,
        linkName: linkName
    }, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        border: [
            "blockend"
        ],
        padding: brlSpacing.padding,
        stid: "air-smart-shopping-brand-result-listing"
    }, /* @__PURE__ */ React8.createElement(UitkCardContentSection2, null, link && /* @__PURE__ */ React8.createElement(UitkCardLink, null, /* @__PURE__ */ React8.createElement(UILinkAction, {
        data: link
    })), /* @__PURE__ */ React8.createElement(UitkLayoutFlex2, {
        wrap: "nowrap",
        justifyContent: "start",
        space: "two",
        alignContent: "start"
    }, ((_logo = logo) === null || _logo === void 0 ? void 0 : _logo.standard) && /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, {
        grow: 0
    }, /* @__PURE__ */ React8.createElement(Viewport, null, /* @__PURE__ */ React8.createElement(ViewSmall, null, /* @__PURE__ */ React8.createElement(EGDSMark, {
        data: logo.standard,
        size: 8
    })), /* @__PURE__ */ React8.createElement(ViewMedium, null, /* @__PURE__ */ React8.createElement(EGDSMark, {
        data: logo.standard,
        size: 7
    })))), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, {
        grow: 8,
        minWidth: "half_width",
        alignSelf: "center"
    }, /* @__PURE__ */ React8.createElement(UitkHeading2, {
        size: 7
    }, advertiserName)), badge && /* @__PURE__ */ React8.createElement(UitkLayoutPosition2, {
        position: {
            top: "three",
            right: "three"
        }
    }, /* @__PURE__ */ React8.createElement(EGDSStandardBadge, {
        data: badge
    }))), /* @__PURE__ */ React8.createElement(UitkLayoutFlex2, {
        direction: "column",
        justifyContent: "start"
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React8.createElement(UitkHeading2, {
        size: 7
    }, heading))), /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React8.createElement(UitkText2, {
        size: 200,
        weight: "regular",
        spacing: "one"
    }, paragraph)), ((_callToAction = callToAction) === null || _callToAction === void 0 ? void 0 : _callToAction.action) && /* @__PURE__ */ React8.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        margin: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLink2, {
        size: "small",
        inline: true
    }, /* @__PURE__ */ React8.createElement(UILinkAction, {
        data: callToAction.action
    }, callToAction.text))))))));
};
LazyBrandResultListingSmartShoppingContent.displayName = "LazyBrandResultListingSmartShoppingContent";
// src/components/brand-result-listing-flights/brand-result-listing-flights.tsx
var __Query = gql5(_templateObject4(), EGDSStandardBadge.fragment, EGDSMark.fragment, UILinkAction.fragment, clientSideAnalyticsFragment);
var BrandResultListingFlightsQueryComponent = function(props) {
    var _data_sponsoredContent_brandResultListingFlights_beacons, _data_sponsoredContent_brandResultListingFlights, _data_sponsoredContent, _data, _data_sponsoredContent1;
    var impressionOnly = props.impressionOnly, inputs = props.inputs, skipSsr = props.skipSsr, _props_batchKey = props.batchKey, batchKey = _props_batchKey === void 0 ? DEFAULT_SPONSORED_BATCH_KEY : _props_batchKey, _props_smartShopping = props.smartShopping, smartShopping = _props_smartShopping === void 0 ? false : _props_smartShopping;
    var _React9_useState = _sliced_to_array(React9.useState(0), 2), lazyOffset = _React9_useState[0], setLazyOffset = _React9_useState[1];
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        fetchPolicy: DEFAULT_SPONSORED_FETCH_POLICY
    }), data = _useQuery.data, error = _useQuery.error;
    var viewabilityBeacon = (_data = data) === null || _data === void 0 ? void 0 : (_data_sponsoredContent = _data.sponsoredContent) === null || _data_sponsoredContent === void 0 ? void 0 : (_data_sponsoredContent_brandResultListingFlights = _data_sponsoredContent.brandResultListingFlights) === null || _data_sponsoredContent_brandResultListingFlights === void 0 ? void 0 : (_data_sponsoredContent_brandResultListingFlights_beacons = _data_sponsoredContent_brandResultListingFlights.beacons) === null || _data_sponsoredContent_brandResultListingFlights_beacons === void 0 ? void 0 : _data_sponsoredContent_brandResultListingFlights_beacons.viewabilityBeacon;
    var componentRef = useMesoViewability({
        viewabilityBeacon: viewabilityBeacon
    }).componentRef;
    React9.useEffect(function() {
        setLazyOffset(window.innerHeight);
    }, []);
    if (error || !data || !((_data_sponsoredContent1 = data.sponsoredContent) === null || _data_sponsoredContent1 === void 0 ? void 0 : _data_sponsoredContent1.brandResultListingFlights)) {
        return null;
    }
    var link = data.sponsoredContent.brandResultListingFlights.link;
    return !smartShopping ? /* @__PURE__ */ React9.createElement(UitkSpacing3, {
        margin: {
            blockend: "three"
        },
        stid: "flights-brand-result-listing"
    }, /* @__PURE__ */ React9.createElement(UitkCard, {
        ref: componentRef
    }, link && /* @__PURE__ */ React9.createElement(UitkCardLink2, null, /* @__PURE__ */ React9.createElement(UILinkAction, {
        data: link
    })), /* @__PURE__ */ React9.createElement(Viewport2, null, /* @__PURE__ */ React9.createElement(ViewSmall2, null, /* @__PURE__ */ React9.createElement(LazyLoad, {
        offset: lazyOffset
    }, /* @__PURE__ */ React9.createElement(LazyBrandResultListingFlightsContent, {
        data: data.sponsoredContent.brandResultListingFlights,
        impressionOnly: impressionOnly
    }))), /* @__PURE__ */ React9.createElement(ViewMedium2, null, /* @__PURE__ */ React9.createElement(LazyLoad, {
        offset: lazyOffset / 2
    }, /* @__PURE__ */ React9.createElement(LazyBrandResultListingFlightsContent, {
        data: data.sponsoredContent.brandResultListingFlights,
        impressionOnly: impressionOnly
    })))))) : /* @__PURE__ */ React9.createElement("div", {
        ref: componentRef
    }, /* @__PURE__ */ React9.createElement(Viewport2, null, /* @__PURE__ */ React9.createElement(ViewSmall2, null, /* @__PURE__ */ React9.createElement(LazyLoad, {
        offset: lazyOffset
    }, /* @__PURE__ */ React9.createElement(LazyBrandResultListingSmartShoppingContent, {
        data: data.sponsoredContent.brandResultListingFlights,
        impressionOnly: impressionOnly
    }))), /* @__PURE__ */ React9.createElement(ViewMedium2, null, /* @__PURE__ */ React9.createElement(LazyLoad, {
        offset: lazyOffset / 2
    }, /* @__PURE__ */ React9.createElement(LazyBrandResultListingSmartShoppingContent, {
        data: data.sponsoredContent.brandResultListingFlights,
        impressionOnly: impressionOnly
    })))));
};
BrandResultListingFlightsQueryComponent.displayName = "sharedui-BrandResultListingFlights";
var BrandResultListingFlights = withAdBlockDetect(BrandResultListingFlightsQueryComponent);
BrandResultListingFlights.displayName = "sharedui-BrandResultListingFlights";
export { BrandResultListingFlights }; /* istanbul ignore file -- @preserve */ 
//# sourceMappingURL=index.js.map